var map = {
	"./mobile/introduceicon1.png": 2298,
	"./mobile/introduceicon2.png": 7577,
	"./mobile/introduceicon3.png": 5605,
	"./mobile/introduceicon4.png": 9512,
	"./mobileBlack/introduceicon1.png": 4262,
	"./mobileBlack/introduceicon2.png": 7590,
	"./mobileBlack/introduceicon3.png": 3260,
	"./mobileBlack/introduceicon4.png": 4848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;